/**
 * Shared tone (valence) typing for the chat presentation primitives —
 * `KpiTile`, `Callout`, `Badge`. Exporting the type from one place keeps
 * the prop signature identical across the three components, which is what
 * lets a caller (or the LLM) reach for the same `tone` value regardless of
 * which primitive it ends up rendering.
 *
 * `'positive'` | `'negative'` | `'neutral'` are the only legal values; the
 * mapping to actual colours lives in `tokens.css` (the
 * `--valence-{positive,negative,neutral}-*` CSS variables) and in
 * `mcp/tools/style-guide.ts` (the `valence` block returned by
 * `get_style_guide`). The two sides MUST stay in sync — the components
 * branch on the literal string and pick the matching `--valence-*` var.
 */

export type Tone = 'positive' | 'negative' | 'neutral';

/** Runtime-validate an unknown string into a `Tone`, falling back to `'neutral'`. */
export function coerceTone(input: unknown): Tone {
  if (input === 'positive' || input === 'negative' || input === 'neutral') return input;
  return 'neutral';
}
